import $http from '../../../axios-instance';
import Swal from 'sweetalert2';

/**
 * Ver detalles del producto mediante la url del qr.
 *
 * @param {*} commit
 * @param {*} hashKey
 * @author Fernando Claros
 */
export async function getDetailsUsingTheQrUrl({ commit }, hashKey) {
    commit('dashboard/load', true, { root: true });
    commit('setLoading', true);

    await $http.get(`visualizer-qr/product/${hashKey}`)
        .then(({ data: response }) => commit('setProductVisualized', response.data))
        .catch(() => {

            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: 'Error al intentar procesar la URL.',
                showConfirmButton: true
            }).then(() => window.location.assign(process.env.VUE_APP_ENDPOINT_WEB_SOLUQUIM));

        })
        .finally(() => {
            commit('dashboard/load', false, { root: true })
            commit('setLoading', false)
        })
}

/**
 * Descargar el archivo del adjunto.
 *
 * @param {*} commit
 * @param {*} id: identificador del adjunto
 * @param {*} nameProduct: nombre del producto
 * @author Fernando Claros
 */
export async function downloadAttachmentFile({ commit }, { id, nameProduct }) {
    commit('dashboard/load', true, { root: true });
    commit('setLoadingDownloadAttachment', {
        id,
        status: true
    });

    await $http.get(`visualizer-qr/download-attachment/product?idAttachment=${id}`)
        .then(({ data: response, status }) => {

            if (status !== 200) return false;

            try {

                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Adjuntos del producto',
                    text: response.message,
                    showConfirmButton: true
                });

                let linkTemporary = document.createElement("a");
                document.body.appendChild(linkTemporary);

                linkTemporary.setAttribute("type", "hidden");
                linkTemporary.href = `data:application/octet-stream;base64,${response.data.file}`;
                linkTemporary.download = `${nameProduct}-adjunto-${id}.${response.data.extension}`;
                linkTemporary.click();

                document.body.removeChild(linkTemporary);

            } catch (e) {
                Swal.fire({
                    position: 'center',
                    icon: 'info',
                    title: 'Adjuntos del producto',
                    text: response.message,
                    showConfirmButton: true
                });
            }

        })
        .catch(error => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Adjuntos del producto',
                text: error.message,
                showConfirmButton: true
            });
        })
        .finally(() => {
            commit('dashboard/load', false, { root: true });
            commit('setLoadingDownloadAttachment', {
                id: null,
                status: false
            });
        });
}
